<ng-container *transloco="let t; read: 'configuration'">
<div class="fix-action-row modal-body">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{ t('ratingPeriods.editTitle') }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid grid-cols-2 gap-4 gap-x-10" [formGroup]="ratingPeriodForm">

      <div class="col-span-full mt-2">
        @if (data) {
          <div>
            <span class="global-font-bold">{{ t('ratingPeriods.nameLabel') }}</span>
            <!-- Server-supplied rating period name. -->
            <p>{{this.data.data.ratingPeriodName}}</p>
          </div>
        }
      </div>

      <div class="col-span-full md:col-span-1">
        <drdp-date-picker [label]="t('common.startDate')" [initialDate]="StartDate?.value" [isRequired]="true" [minDate]="minStart"
          [maxDate]="maxEnd" (emitDate)="handleDate($event, 'StartDate')">
        </drdp-date-picker>
      </div>

      <div class="col-span-full md:col-span-1 mb-8">
        <drdp-date-picker [label]="t('common.endDate')" [initialDate]="EndDate?.value" [isRequired]="true" [minDate]="minStart"
          [maxDate]="maxEnd" (emitDate)="handleDate($event, 'EndDate')">
        </drdp-date-picker>
        @if (ratingPeriodForm.hasError('dateMismatch')) {
          <mat-error> {{ t('common.invalidDateRange') }}</mat-error>
        }
      </div>

    </form>

  </div>
  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn class="mx-2" color="cancel" mat-button mat-dialog-close>{{ t('common.cancel') }}</drdp-btn>
    @if (ratingPeriodForm.valid) {
      <drdp-btn mat-button [mat-dialog-close]="onSubmit()" [disabled]="false"
      cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
    @if (!ratingPeriodForm.valid) {
      <drdp-btn mat-button [disabled]="true" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
  </div>
</div>
</ng-container>
